import { Workspace } from "../../types/workspace";
import { WorkspacesTableRowDefinition } from "./types";

const generateDefaultName = (
  originName: string,
  name: string,
  orgNames: string[],
  index?: number
): string => {
  if (orgNames.length > 0) {
    const nameIsNotUnique = orgNames.map((name) => name.trim()).includes(name);
    let nextIndex = index ? index + 1 : 2;
    if (nameIsNotUnique) {
      return generateDefaultName(
        originName,
        originName + " (" + nextIndex + ")",
        orgNames,
        nextIndex++
      );
    }
  }
  return name;
};

export function isNameDuplicate(
  name: string,
  existingNames: string[]
): boolean {
  const normalizedName = name.toLowerCase().trim();
  const normalizedExistingNames = existingNames.map((name) =>
    name.toLowerCase().trim()
  );
  return normalizedExistingNames.includes(normalizedName);
}

export function getWorkspaceNames(workspaces: Workspace[]): string[] {
  return workspaces.map((workspace) => workspace.name);
}

export function getDefaultWorkspaceName(
  workspaces: Workspace[],
  name: string | null = "User"
) {
  const date = new Date();
  const formattedDate = date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  const constructedName = `${name}'s Project - ${formattedDate}`;
  const existingWorkspaceNames = getWorkspaceNames(workspaces);

  return generateDefaultName(
    constructedName,
    constructedName,
    existingWorkspaceNames
  );
}

export function createWorkspaceRows(
  workspaces: Workspace[]
): WorkspacesTableRowDefinition[] {
  if (workspaces.length === 0) {
    return [];
  }

  return workspaces.map((workspace) => {
    return {
      id: workspace.id,
      name: workspace.name,
      description: workspace.description,
      owner: workspace.owner_email,
      visibilityStatus: workspace.visibility,
      creationDate: workspace.inserted_at,
      lastUpdate: workspace.updated_at,
      permissions: workspace.permissions,
    };
  });
}

export function areStringsEqual(
  str1: string | undefined,
  str2: string | undefined
): boolean {
  return str1?.toLowerCase().trim() === str2?.toLowerCase().trim();
}
